import type { KanbanTileComponent } from './tileTypes'

export type KanbanTileLayoutRow =
  | { kind: 'full'; component: KanbanTileComponent; key: string }
  | { kind: 'grid'; components: KanbanTileComponent[]; key: string }

export type KanbanTileLayout = {
  header: Extract<KanbanTileComponent, { component: 'Label' }>[]
  rows: KanbanTileLayoutRow[]
  footer: KanbanTileComponent[]
}

const isGridField = (component: KanbanTileComponent): boolean => {
  if (
    component.component === 'Date' ||
    component.component === 'Number' ||
    component.component === 'Boolean'
  ) {
    return true
  }

  if (component.component === 'Tags') {
    return !component.props.multi
  }

  return false
}

export const buildKanbanTileLayout = (
  components: KanbanTileComponent[],
): KanbanTileLayout => {
  const layout: KanbanTileLayout = {
    header: [],
    rows: [],
    footer: [],
  }

  let gridBatch: KanbanTileComponent[] = []
  let gridBatchIndex = 0

  const flushGrid = () => {
    if (gridBatch.length === 0) return
    layout.rows.push({
      kind: 'grid',
      components: gridBatch,
      key: `grid-${gridBatchIndex++}`,
    })
    gridBatch = []
  }

  components.forEach((component, index) => {
    if (component.component === 'Label') {
      flushGrid()
      layout.header.push(component)
      return
    }

    if (component.component === 'WorkflowChips') {
      flushGrid()
      layout.footer.push(component)
      return
    }

    if (isGridField(component)) {
      gridBatch.push(component)
      if (gridBatch.length === 2) {
        flushGrid()
      }
      return
    }

    flushGrid()
    layout.rows.push({
      kind: 'full',
      component,
      key: `full-${index}`,
    })
  })

  flushGrid()
  return layout
}
